export default "__VITE_ASSET__CvZU2gbq__"